module.exports = __webpack_public_path__ + "img/357.a43cc484.png";